import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6809e226"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "stock-header",
  class: "row mb-8 d-flex align-items-center"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-12 col-md-2" }, [
  /*#__PURE__*/_createElementVNode("h2", { style: {"color":"var(--cor_texto_1)"} }, "Estoque")
], -1))
const _hoisted_3 = { class: "col-sm-12 col-md-10" }
const _hoisted_4 = { class: "row g-4" }
const _hoisted_5 = { class: "col-12 col-sm-8 col-xl-6 d-flex justify-content-end align-items-center" }
const _hoisted_6 = {
  class: "w-100",
  style: {"position":"relative","height":"3.3rem"}
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-search",
  "aria-hidden": "true",
  style: {"position":"absolute","cursor":"text","right":"1.15rem","top":"0.9rem","margin":"0","padding":"0","font-size":"1.5rem","color":"var(--cor_btn_1)"}
}, null, -1))
const _hoisted_8 = { class: "col-6 col-sm-2 col-xl-3" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-plus",
  "aria-hidden": "true",
  style: {"margin":"0","padding":"0","font-size":"1.5rem","color":"var(--cor_btn_1)"}
}, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-none d-xl-inline ms-4" }, "Adicionar", -1))
const _hoisted_11 = { class: "col-6 col-sm-2 col-xl-3" }
const _hoisted_12 = { class: "btn background_btn_1_opct w-100" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-upload",
  "aria-hidden": "true",
  style: {"margin":"0","padding":"0","font-size":"1.5rem","color":"var(--cor_btn_1)"}
}, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-none d-xl-inline ms-4" }, "Nota Fiscal", -1))
const _hoisted_15 = {
  id: "box-table-competitors",
  class: "background_1 card"
}
const _hoisted_16 = { style: {"white-space":"nowrap"} }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { key: 2 }
const _hoisted_22 = { style: {"margin-top":"1rem"} }
const _hoisted_23 = { style: {"margin-top":"1rem"} }
const _hoisted_24 = { style: {"margin-top":"1rem"} }
const _hoisted_25 = {
  key: 0,
  style: {"color":"var(--cor_indicadores_1)"}
}
const _hoisted_26 = {
  key: 1,
  style: {"color":"var(--cor_indicadores_4)"}
}
const _hoisted_27 = {
  key: 2,
  style: {"color":"var(--cor_indicadores_4)"}
}
const _hoisted_28 = {
  key: 3,
  style: {"color":"var(--cor_indicadores_4)"}
}
const _hoisted_29 = {
  key: 0,
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_30 = { "clip-path": "url(#clip0_1919_2363)" }
const _hoisted_31 = ["fill"]
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_1919_2363" }, [
    /*#__PURE__*/_createElementVNode("rect", {
      width: "20",
      height: "20",
      fill: "white"
    })
  ])
], -1))
const _hoisted_33 = {
  key: 1,
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_34 = ["fill"]
const _hoisted_35 = ["onClick"]
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-eye",
  "aria-hidden": "true",
  style: {"color":"white","margin":"0","padding":"0"}
}, null, -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ps-2" }, " Ver mais ", -1))
const _hoisted_38 = [
  _hoisted_36,
  _hoisted_37
]
const _hoisted_39 = {
  key: 2,
  id: "box-table-stores",
  class: "background_1 card d-flex flex-column justify-content-center align-items-center",
  style: {"background-color":"transparent !important","box-shadow":"none !important"}
}
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "p-5 d-flex flex-column justify-content-center align-items-center",
  style: {"gap":"2rem"}
}, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "fa fa-box-open",
    "aria-hidden": "true",
    style: {"margin":"0","padding":"0","font-size":"6rem","color":"#B5B5C3"}
  }),
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"#B5B5C3"} }, " Não há nada para mostrar ")
], -1))
const _hoisted_41 = [
  _hoisted_40
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_CampEmptyListFeedback = _resolveComponent("CampEmptyListFeedback")!
  const _component_CampTableSortRowsByColumn = _resolveComponent("CampTableSortRowsByColumn")!
  const _component_CampTableTh = _resolveComponent("CampTableTh")!
  const _component_CampTableTd = _resolveComponent("CampTableTd")!
  const _component_CampTable = _resolveComponent("CampTable")!
  const _component_CampFooterPaginationControl = _resolveComponent("CampFooterPaginationControl")!
  const _component_StockInfo = _resolveComponent("StockInfo")!
  const _component_ModalUploadInvoiceXMLFile = _resolveComponent("ModalUploadInvoiceXMLFile")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_el_input, {
                class: "h-100",
                modelValue: _ctx.filterDom,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filterDom) = $event)),
                placeholder: "Filtrar por loja ou produto nessa página",
                type: "text"
              }, null, 8, ["modelValue"]),
              _hoisted_7
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_RouterLink, {
              to: '/estoque/adicionar',
              id: "buttonAddTop",
              class: "btn btn_background_1 w-100"
            }, {
              default: _withCtx(() => [
                _hoisted_9,
                _hoisted_10
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("label", _hoisted_12, [
              _hoisted_13,
              _hoisted_14,
              _createElementVNode("input", {
                class: "d-none",
                type: "file",
                onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleXMLFileChange && _ctx.handleXMLFileChange(...args))),
                multiple: ""
              }, null, 32)
            ])
          ])
        ])
      ])
    ]),
    (_ctx.isLoadList)
      ? (_openBlock(), _createBlock(_component_el_skeleton, {
          key: 0,
          rows: 5
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_15, [
      false
        ? (_openBlock(), _createBlock(_component_CampEmptyListFeedback, { key: 0 }))
        : _createCommentVNode("", true),
      (!_ctx.isLoadList && _ctx.stockList.length > 0)
        ? (_openBlock(), _createBlock(_component_CampTable, { key: 1 }, {
            default: _withCtx(() => [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", _hoisted_16, [
                  _createVNode(_component_CampTableTh, null, {
                    default: _withCtx(() => [
                      _createTextVNode(" Loja "),
                      _createVNode(_component_CampTableSortRowsByColumn, {
                        "onUpdate:rowsSortedByColumn": _ctx.sortRowsByColumn,
                        sortComponentCore: _ctx.sortComponentCore,
                        column: "store"
                      }, null, 8, ["onUpdate:rowsSortedByColumn", "sortComponentCore"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_CampTableTh, null, {
                    default: _withCtx(() => [
                      _createTextVNode(" Nº Nota Fiscal "),
                      _createVNode(_component_CampTableSortRowsByColumn, {
                        "onUpdate:rowsSortedByColumn": _ctx.sortRowsByColumn,
                        sortComponentCore: _ctx.sortComponentCore,
                        column: "movement_id"
                      }, null, 8, ["onUpdate:rowsSortedByColumn", "sortComponentCore"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_CampTableTh, null, {
                    default: _withCtx(() => [
                      _createTextVNode(" Nº Venda "),
                      _createVNode(_component_CampTableSortRowsByColumn, {
                        "onUpdate:rowsSortedByColumn": _ctx.sortRowsByColumn,
                        sortComponentCore: _ctx.sortComponentCore,
                        column: "movement_id"
                      }, null, 8, ["onUpdate:rowsSortedByColumn", "sortComponentCore"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_CampTableTh, null, {
                    default: _withCtx(() => [
                      _createTextVNode(" Produto "),
                      _createVNode(_component_CampTableSortRowsByColumn, {
                        "onUpdate:rowsSortedByColumn": _ctx.sortRowsByColumn,
                        sortComponentCore: _ctx.sortComponentCore,
                        column: "product"
                      }, null, 8, ["onUpdate:rowsSortedByColumn", "sortComponentCore"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_CampTableTh, { class: "text-center" }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Qtd "),
                      _createVNode(_component_CampTableSortRowsByColumn, {
                        "onUpdate:rowsSortedByColumn": _ctx.sortRowsByColumn,
                        sortComponentCore: _ctx.sortComponentCore,
                        column: "quantity"
                      }, null, 8, ["onUpdate:rowsSortedByColumn", "sortComponentCore"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_CampTableTh, { class: "text-center" }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Data/Hora (Operação) "),
                      _createVNode(_component_CampTableSortRowsByColumn, {
                        "onUpdate:rowsSortedByColumn": _ctx.sortRowsByColumn,
                        sortComponentCore: _ctx.sortComponentCore,
                        column: "created_at"
                      }, null, 8, ["onUpdate:rowsSortedByColumn", "sortComponentCore"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_CampTableTh, { class: "text-center" }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Data/Hora (Emissão) ")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_CampTableTh, { class: "text-center" }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Data/Hora (Expiração) ")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_CampTableTh, null, {
                    default: _withCtx(() => [
                      _createTextVNode(" Responsável "),
                      _createVNode(_component_CampTableSortRowsByColumn, {
                        "onUpdate:rowsSortedByColumn": _ctx.sortRowsByColumn,
                        sortComponentCore: _ctx.sortComponentCore,
                        column: "name"
                      }, null, 8, ["onUpdate:rowsSortedByColumn", "sortComponentCore"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_CampTableTh, { class: "text-center" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Tipo")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_CampTableTh, { class: "text-center" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Status")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_CampTableTh, { class: "text-center" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Ações")
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stockList
              .filter((item) => (item.store
              .toLowerCase()
              .includes(_ctx.filterDom.toLowerCase())
                || item?.product?.toLowerCase().includes(_ctx.filterDom.toLowerCase())
                || item?.movement_id?.toLowerCase().includes(_ctx.filterDom.toLowerCase())
                || item?.store?.toLowerCase().includes(_ctx.filterDom.toLowerCase())
                || item?.user?.toLowerCase().includes(_ctx.filterDom.toLowerCase())
                || item?.competitor?.toLowerCase().includes(_ctx.filterDom.toLowerCase())
                || _ctx.moment(item?.created_at).format('DD/MM/YYYY HH:mm:ss')?.toLowerCase().includes(_ctx.filterDom.toLowerCase())
            )), (stock) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    class: "tableProduct",
                    key: stock.id
                  }, [
                    _createVNode(_component_CampTableTd, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(stock.store), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_CampTableTd, null, {
                      default: _withCtx(() => [
                        (stock.movement_type === 'output')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_17, "-"))
                          : (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(stock.movement_id), 1))
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_CampTableTd, null, {
                      default: _withCtx(() => [
                        (stock.movement_type === 'input')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_19, "-"))
                          : (stock.movement_type === 'return')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_20, "-"))
                            : (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(stock.movement_id), 1))
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_CampTableTd, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(stock.product), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_CampTableTd, { class: "text-center" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(stock.quantity), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_CampTableTd, { class: "text-center" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.moment(stock.created_at).format('DD/MM/YYYY HH:mm:ss')), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_CampTableTd, { class: "text-center" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_23, _toDisplayString(`${stock.invoice_issue_date ? _ctx.moment(stock.invoice_issue_date).format('DD/MM/YYYY HH:mm:ss') : '-'}`), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_CampTableTd, { class: "text-center" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_24, _toDisplayString(`${stock.expires_at ? _ctx.moment(stock.expires_at).format('DD/MM/YYYY HH:mm:ss') : '-'}`), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_CampTableTd, null, {
                      default: _withCtx(() => [
                        _createElementVNode("span", null, _toDisplayString(stock.user || stock.competitor || '-'), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_CampTableTd, { class: "text-center" }, {
                      default: _withCtx(() => [
                        (stock.movement_type === 'input')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_25, " Entrada "))
                          : _createCommentVNode("", true),
                        (stock.movement_type === 'output')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_26, " Saida "))
                          : _createCommentVNode("", true),
                        (stock.movement_type === 'return')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_27, " Estorno "))
                          : _createCommentVNode("", true),
                        (stock.movement_type === 'expiration')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_28, " Expirado "))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_CampTableTd, { class: "text-center" }, {
                      default: _withCtx(() => [
                        (stock.status !== 'cancelado')
                          ? (_openBlock(), _createElementBlock("svg", _hoisted_29, [
                              _createElementVNode("g", _hoisted_30, [
                                _createElementVNode("path", {
                                  d: "M19.6875 10C19.6875 15.3503 15.3503 19.6875 10 19.6875C4.64973 19.6875 0.3125 15.3503 0.3125 10C0.3125 4.64973 4.64973 0.3125 10 0.3125C15.3503 0.3125 19.6875 4.64973 19.6875 10ZM8.87945 15.1295L16.067 7.94195C16.311 7.69789 16.311 7.30215 16.067 7.05809L15.1831 6.17422C14.939 5.93012 14.5433 5.93012 14.2992 6.17422L8.4375 12.0359L5.70082 9.29918C5.45676 9.05512 5.06102 9.05512 4.81691 9.29918L3.93305 10.183C3.68898 10.4271 3.68898 10.8229 3.93305 11.0669L7.99555 15.1294C8.23965 15.3735 8.63535 15.3735 8.87945 15.1295Z",
                                  fill: `var(--cor_indicadores_1)`
                                }, null, 8, _hoisted_31)
                              ]),
                              _hoisted_32
                            ]))
                          : (_openBlock(), _createElementBlock("svg", _hoisted_33, [
                              _createElementVNode("path", {
                                d: "M10 0.3125C4.64844 0.3125 0.3125 4.64844 0.3125 10C0.3125 15.3516 4.64844 19.6875 10 19.6875C15.3516 19.6875 19.6875 15.3516 19.6875 10C19.6875 4.64844 15.3516 0.3125 10 0.3125ZM14.75 12.543C14.9336 12.7266 14.9336 13.0234 14.75 13.207L13.2031 14.75C13.0195 14.9336 12.7227 14.9336 12.5391 14.75L10 12.1875L7.45703 14.75C7.27344 14.9336 6.97656 14.9336 6.79297 14.75L5.25 13.2031C5.06641 13.0195 5.06641 12.7227 5.25 12.5391L7.8125 10L5.25 7.45703C5.06641 7.27344 5.06641 6.97656 5.25 6.79297L6.79688 5.24609C6.98047 5.0625 7.27734 5.0625 7.46094 5.24609L10 7.8125L12.543 5.25C12.7266 5.06641 13.0234 5.06641 13.207 5.25L14.7539 6.79688C14.9375 6.98047 14.9375 7.27734 14.7539 7.46094L12.1875 10L14.75 12.543Z",
                                fill: `var(--cor_indicadores_4)`
                              }, null, 8, _hoisted_34)
                            ]))
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_CampTableTd, { class: "text-center py-1" }, {
                      default: _withCtx(() => [
                        _createElementVNode("button", {
                          class: "btn btn-sm background_btn_1_opct w-100",
                          onClick: ($event: any) => (_ctx.openModalInfo(stock)),
                          style: {"white-space":"nowrap"}
                        }, _hoisted_38, 8, _hoisted_35)
                      ]),
                      _: 2
                    }, 1024)
                  ]))
                }), 128))
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (!_ctx.stockList?.length && !_ctx.isLoadList)
        ? (_openBlock(), _createElementBlock("div", _hoisted_39, _hoisted_41))
        : _createCommentVNode("", true)
    ]),
    (!_ctx.isLoadList && _ctx.stockList.length > 0)
      ? (_openBlock(), _createBlock(_component_CampFooterPaginationControl, {
          key: 1,
          class: "mt-5 mb-20",
          index: _ctx.pageID,
          total: _ctx.pageTotal,
          "onGet:UpdatedPageID": _cache[2] || (_cache[2] = (ID) => _ctx.handleGetStockPagination(ID))
        }, null, 8, ["index", "total"]))
      : _createCommentVNode("", true),
    _createVNode(_component_StockInfo, {
      openClose: _ctx.openModalInfoRef,
      detailList: _ctx.detailList,
      handleGetStock: _ctx.handleGetStock
    }, null, 8, ["openClose", "detailList", "handleGetStock"]),
    _createVNode(_component_ModalUploadInvoiceXMLFile, {
      header: "Subir Nota Fiscal (XML)",
      maxUploads: 15,
      inputEventFromXMLFileList: _ctx.inputEventFromXMLFileList,
      toggleModalUploadInvoice: _ctx.toggleModalUploadInvoice,
      updateStock: _ctx.handleGetStock
    }, null, 8, ["inputEventFromXMLFileList", "toggleModalUploadInvoice", "updateStock"])
  ]))
}